import React from 'react';
import {
  Box,
  Typography,
  Icons,
  IconButton,
  useTheme,
} from '@ublend-npm/aulaui-core';
import { Dialog, Button } from '@mui/material';
import { HOME_TOUR_BUTTONS } from './homeTourContent';

export type HomeTourWelcomeProps = {
  open: boolean;
  title: string;
  description: string;
  onStart: () => void;
  onDismiss: () => void;
};

const HomeTourWelcome: React.FC<HomeTourWelcomeProps> = ({
  open,
  title,
  description,
  onStart,
  onDismiss,
}) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  return (
    <Dialog
      open={open}
      onClose={onDismiss}
      aria-labelledby="home-tour-welcome-title"
      aria-describedby="home-tour-welcome-description"
      PaperProps={{
        sx: {
          bgcolor: theme.palette.background.paper,
          borderRadius: 2,
          py: 3,
          px: 2.5,
          gap: 2,
          maxWidth: 400,
        },
      }}
    >
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="flex-start"
      >
        <Typography
          variant="subtitle1"
          fontWeight="medium"
          id="home-tour-welcome-title"
          sx={{ color: theme.palette.primary.main, pr: 1 }}
        >
          {title}
        </Typography>
        <IconButton
          onClick={onDismiss}
          aria-label="Close"
          size="small"
          sx={{
            color: theme.palette.text.secondary,
            '&:hover': { color: theme.palette.text.primary },
          }}
        >
          <Icons.Close fontSize="small" />
        </IconButton>
      </Box>

      <Typography
        id="home-tour-welcome-description"
        variant="body2"
        sx={{ color: theme.palette.text.secondary, lineHeight: 1.6 }}
      >
        {description}
      </Typography>

      <Box display="flex" justifyContent="flex-end" gap={1.5} mt={1}>
        <Button
          onClick={onDismiss}
          variant="text"
          sx={{
            textTransform: 'none',
            color: theme.palette.text.secondary,
          }}
        >
          {HOME_TOUR_BUTTONS.skip}
        </Button>
        <Button
          onClick={onStart}
          variant="contained"
          sx={{
            textTransform: 'none',
            bgcolor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            '&:hover': {
              bgcolor: isDark
                ? theme.palette.primary.light
                : theme.palette.primary.dark,
            },
          }}
        >
          {HOME_TOUR_BUTTONS.start}
        </Button>
      </Box>
    </Dialog>
  );
};

export default HomeTourWelcome;
